import React from 'react';
import { useHistory } from 'react-router-dom';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { Dialogs, useDialogManager } from '@/modules/Dialogs';

export type MatchHeadersBlockPromptProps = {
  when: boolean;
};

export default function MatchHeadersBlockPrompt({
  when,
}: MatchHeadersBlockPromptProps) {
  const { openDialog, closeDialog } = useDialogManager();
  const history = useHistory();
  const unblockRef = React.useRef<() => void>(null);

  function handleShowDialog(pathname: string) {
    openDialog(Dialogs.CONFIRMATION, {
      children: translate('DATA_UPLOADS_PREVENT_NAVIGATION_MESSAGE'),
      onCancel: closeDialog,
      onClose: closeDialog,
      onConfirm: () => {
        if (unblockRef?.current !== null) unblockRef.current();
        history.push(pathname);
        closeDialog();
      },
    });
  }

  React.useEffect(() => {
    // useHistory()'s block method in react-router-dom returns a different type than expected
    // https://stackoverflow.com/questions/63100443/usehistorys-block-method-in-react-router-dom-returns-a-different-type-than-ex
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    unblockRef.current = history.block((location) => {
      if (when) {
        handleShowDialog(location.pathname);
        return false;
      }
      return true;
    });
    return () => {
      if (unblockRef?.current !== null) unblockRef.current();
    };
  }, [when]);

  return null;
}
